export default "__VITE_ASSET__BwPk$U$2__"